import theme from "src/themes";

const trendReportHighlightColorMap: { [key: string]: string } = {
  "3-inv-total-inv": theme.palette.primary.contrastText,
  "3-total-freight": theme.palette.primary.contrastText,
  "3-adj-margin-ecomm-freight": theme.palette.primary.contrastText,
  "3-ending-date": theme.palette.secondary.main,
  "3-inv-grocery": theme.palette.secondary.main,
  "3-inv-frozen": theme.palette.secondary.main,
  "3-inv-hbc": theme.palette.secondary.main,
  "3-inv-deli": theme.palette.secondary.main,
  "3-inv-beerorwine": theme.palette.secondary.main,
  "3-inv-gm": theme.palette.secondary.main,
  "3-inv-produce": theme.palette.secondary.main,
  "3-inv-meat": theme.palette.secondary.main
};

const trendReportTextColorMap: { [key: string]: string } = {
  "3-ending-date": theme.palette.primary.dark,
  "3-inv-grocery": theme.palette.primary.dark,
  "3-inv-frozen": theme.palette.primary.dark,
  "3-inv-hbc": theme.palette.primary.dark,
  "3-inv-deli": theme.palette.primary.dark,
  "3-inv-beerorwine": theme.palette.primary.dark,
  "3-inv-gm": theme.palette.primary.dark,
  "3-inv-produce": theme.palette.primary.dark,
  "3-inv-meat": theme.palette.primary.dark
};

const higlightRows = [
  "3-inv-total-inv",
  "3-total-freight",
  "3-adj-margin-ecomm-freight"
];

const borderTop: { [key: string]: boolean } = {
  "3-inv-total-inv": true,
  "3-total-freight": true
};

export const getTrendReportInventoryObject = (childItem: any) => {
  const [dateA, dateB, dateC, dateD, dateE] = childItem.inventoryCycles;

  const dataObj: any = {
    title: {
      value: childItem?.text,
      bold: childItem?.style?.bold,
      underline: childItem?.style?.underline,
      borderRight: true
    },
    dateC: {
      value: dateC?.amount,
      underline: childItem?.style?.underline,
      bold: childItem?.style?.bold,
      textColor: trendReportTextColorMap[childItem?.key],
      highlightColor: trendReportHighlightColorMap[childItem?.key]
    },
    dateA: {
      value: dateA?.amount,
      bold: childItem?.style?.bold,
      highlightColor: trendReportHighlightColorMap[childItem?.key],
      textColor: trendReportTextColorMap[childItem?.key],
      underline: childItem?.style?.underline
    },
    dateB: {
      value: dateB?.amount,
      highlightColor: trendReportHighlightColorMap[childItem?.key],
      bold: childItem?.style?.bold,
      underline: childItem?.style?.underline,
      textColor: trendReportTextColorMap[childItem?.key]
    },
    dateE: {
      value: dateE?.amount,
      textColor: trendReportTextColorMap[childItem?.key],
      bold: childItem?.style?.bold,
      highlightColor: trendReportHighlightColorMap[childItem?.key],
      underline: childItem?.style?.underline
    },
    dateD: {
      value: dateD?.amount,
      highlightColor: trendReportHighlightColorMap[childItem?.key],
      bold: childItem?.style?.bold,
      underline: childItem?.style?.underline,
      textColor: trendReportTextColorMap[childItem?.key]
    },
    level: childItem?.level,
    isHighlightedRow: childItem?.style?.bold,
    borderTop: borderTop[childItem.key]
  };

  if (higlightRows.includes(childItem?.key)) {
    dataObj.title.highlightColor = trendReportHighlightColorMap[childItem?.key];
  }

  return dataObj;
};

export const getTrendReportFreightObject = (childItem: any) => {
  const [dateA, dateB, dateC, dateD, dateE] = childItem.inventoryCycles;

  const dataObj: any = {
    title: {
      value: childItem?.text,
      bold: childItem?.style?.bold,
      underline: childItem?.style?.underline
    },
    dateA: {
      value: dateA?.amount,
      bold: childItem?.style?.bold,
      highlightColor: trendReportHighlightColorMap[childItem?.key],
      textColor: trendReportTextColorMap[childItem?.key],
      underline: childItem?.style?.underline
    },
    dateB: {
      value: dateB?.amount,
      highlightColor: trendReportHighlightColorMap[childItem?.key],
      bold: childItem?.style?.bold,
      underline: childItem?.style?.underline,
      textColor: trendReportTextColorMap[childItem?.key]
    },
    dateC: {
      value: dateC?.amount,
      bold: childItem?.style?.bold,
      textColor: trendReportTextColorMap[childItem?.key],
      highlightColor: trendReportHighlightColorMap[childItem?.key],
      underline: childItem?.style?.underline
    },
    dateD: {
      value: dateD?.amount,
      bold: childItem?.style?.bold,
      underline: childItem?.style?.underline,
      textColor: trendReportTextColorMap[childItem?.key],
      highlightColor: trendReportHighlightColorMap[childItem?.key]
    },
    dateE: {
      value: dateE?.amount,
      bold: childItem?.style?.bold,
      highlightColor: trendReportHighlightColorMap[childItem?.key],
      underline: childItem?.style?.underline,
      textColor: trendReportTextColorMap[childItem?.key]
    },
    level: childItem?.level,
    isHighlightedRow: childItem?.style?.bold,
    borderTop: borderTop[childItem.key]
  };

  if (higlightRows.includes(childItem?.key)) {
    dataObj.title.highlightColor = trendReportHighlightColorMap[childItem?.key];
  }

  return dataObj;
};
